export const EMAIL_NOT_UNIQUE = 'email_not_unique';
export const INVALID_REQUEST = 'invalid_request';
export const INVITATION_NOT_FOUND = 'invitation_not_found';
export const INVITATION_SSO_ENABLED = 'invitation_sso_enabled';
export const INVITE_CODE_EXPIRED = 'invite_code_expired';
export const INVITE_CODE_USED = 'invite_code_used';
export const LOCAL_AUTHENTICATION_FORBIDDEN = 'local_authentication_forbidden';
export const RECAPTCHA_LOW_SCORE = 'recaptcha_low_score';
export const RECAPTCHA_INVALID_TOKEN = 'recaptcha_invalid_token';

const knownErrors = [
  EMAIL_NOT_UNIQUE,
  INVALID_REQUEST,
  INVITATION_NOT_FOUND,
  INVITATION_SSO_ENABLED,
  INVITE_CODE_EXPIRED,
  INVITE_CODE_USED,
  LOCAL_AUTHENTICATION_FORBIDDEN,
  RECAPTCHA_LOW_SCORE,
  RECAPTCHA_INVALID_TOKEN,
];

export const isKnownError = (type) => knownErrors.includes(type);
